import React from "react";
import ReactDOM from "react-dom/client";
import EmployeeIndex from "./pages/EmployeeIndex";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import MyTeam from "./pages/MyTeam";
import Attendance from "./pages/Attendance";
import OvertimeApplication from "./pages/OvertimeApplication";
import BusinessApplication from "./pages/BusinessApplication";
import AttendanceSummary from "./pages/AttendanceSummary";
import Benefits from "./pages/Benefits";
import ToDo from "./pages/ToDo";
import Payroll from "./pages/Payroll";
import Leaves from "./pages/Leaves";
import Login from "./pages/Login";
import AdminEmployeeIndex from "./pages/Admin/AdminEmployeeIndex";
import AdminMyTeam from "./pages/Admin/AdminMyteam";
import AdminAttendance from "./pages/Admin/AdminAttendance";
import AdminBenefits from "./pages/Admin/AdminBenefits";
import AdminToDo from "./pages/Admin/AdminToDo";
import AddUser from "./pages/Admin/AddUser";
import EditProfile from "./pages/EditProfile";
import ViewProfile from "./pages/ViewProfile";
import AdminSettings from "./pages/Admin/AdminSettings";
import BusinessList from "./pages/BusinessList";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClient from "./api/queryClient";
import { GlobalProvider } from "./contexts/GlobalContext";
import { Bounce, ToastContainer } from "react-toastify";
import "react-toastify/ReactToastify.css";
import "react-toastify/dist/ReactToastify.css";
import ProtectedRoute from "./components/ProtectedRoute";
import OvertimeList from "./pages/OvertimeList";
import LeavesList from "./pages/LeavesList";
import AdminOvertime from "./pages/Admin/AdminOvertime";
import AdminOfficialBusiness from "./pages/Admin/AdminOfficialBusiness";
import AdminEmployeeList from "./pages/Admin/AdminEmployeeList";
import AdminAllowanceList from "./pages/Admin/AdminAllowanceList";
import AdminDeductionList from "./pages/Admin/AdminDeductionList";
import SalaryRecordList from "./pages/Admin/SalaryRecordsList";
import AddSalaryRecord from "./pages/Admin/AddSalaryRecord";
import AddShiftSchedule from "./pages/Admin/AddShiftSchedule";
import ShiftList from "./pages/Admin/ShiftList";
import WorkLocationList from "./pages/Admin/WorkLocationList";
import AddWorkLocation from "./pages/Admin/AddWorkLocation";
import DepartmentList from "./pages/Admin/DepartmentList";
const router = createBrowserRouter([
  {
    path: "/EmployeeIndex",
    element: (
      <ProtectedRoute>
        <EmployeeIndex />
      </ProtectedRoute>
    ),
  },
  {
    path: "/MyTeam",
    element: (
      <ProtectedRoute>
        <MyTeam />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Attendance",
    element: (
      <ProtectedRoute>
        <Attendance />
      </ProtectedRoute>
    ),
  },
  {
    path: "/OvertimeApplication",
    element: (
      <ProtectedRoute>
        <OvertimeApplication />
      </ProtectedRoute>
    ),
  },
  {
    path: "/BusinessApplication",
    element: (
      <ProtectedRoute>
        <BusinessApplication />
      </ProtectedRoute>
    ),
  },
  {
    path: "/AttendanceSummary",
    element: (
      <ProtectedRoute>
        <AttendanceSummary />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Benefits",
    element: (
      <ProtectedRoute>
        <Benefits />
      </ProtectedRoute>
    ),
  },
  {
    path: "/ToDo",
    element: (
      <ProtectedRoute>
        <ToDo />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Payroll",
    element: (
      <ProtectedRoute>
        <Payroll />
      </ProtectedRoute>
    ),
  },
  {
    path: "/OvertimeList",
    element: (
      <ProtectedRoute>
        <OvertimeList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Leaves",
    element: (
      <ProtectedRoute>
        <Leaves />
      </ProtectedRoute>
    ),
  },
  {
    path: "/LeavesList",
    element: (
      <ProtectedRoute>
        <LeavesList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/Login",
    element: <Login />,
  },
  {
    path: "/AdminEmployeeIndex",
    element: <AdminEmployeeIndex />,
  },
  {
    path: "/AdminMyTeam",
    element: <AdminMyTeam />,
  },
  {
    path: "/AdminAttendance",
    element: <AdminAttendance />,
  },
  {
    path: "/AdminBenefits",
    element: <AdminBenefits />,
  },
  {
    path: "/AdminToDo",
    element: <AdminToDo />,
  },
  {
    path: "/AdminOvertime",
    element: <AdminOvertime />,
  },
  {
    path: "/AdminBusiness",
    element: <AdminOfficialBusiness />,
  },
  {
    path: "/AdminEmployeeList",
    element: <AdminEmployeeList />,
  },
  {
    path: "/AddUser",
    element: <AddUser />,
  },
  {
    path: "/EditUser/:id",
    element: <AddUser />,
  },
  {
    path: "/AdminSettings",
    element: <AdminSettings />,
  },
  {
    path: "/AllowanceTypes",
    element: <AdminAllowanceList />,
  },
  {
    path: "/DeductionTypes",
    element: <AdminDeductionList />,
  },
  {
    path: "/SalaryRecord",
    element: <SalaryRecordList />,
  },
  {
    path: "/AddSalaryRecord",
    element: <AddSalaryRecord />,
  },
  {
    path: "/EditSalaryRecord/:id",
    element: <AddSalaryRecord />,
  },
  {
    path: "/AddShiftSchedule",
    element: <AddShiftSchedule />,
  },
  {
    path: "/EditShiftSchedule/:id",
    element: <AddShiftSchedule />,
  },
  {
    path: "/ShiftSchedule",
    element: <ShiftList />,
  },
  {
    path: "/WorkLocations",
    element: <WorkLocationList />,
  },
  {
    path: "/AddWorkLocation",
    element: <AddWorkLocation />,
  },
  {
    path: "/EditWorkLocation/:id",
    element: <AddWorkLocation />,
  },
  {
    path: "/Departments",
    element: <DepartmentList />,
  },
  {
    path: "/BusinessList",
    element: (
      <ProtectedRoute>
        <BusinessList />
      </ProtectedRoute>
    ),
  },
  {
    path: "/OvertimeList",
    element: (
      <ProtectedRoute>
        <OvertimeList />
      </ProtectedRoute>
    ),
  },

  {
    path: "/EditProfile",
    element: (
      <ProtectedRoute>
        <EditProfile />
      </ProtectedRoute>
    ),
  },
  {
    path: "/ViewProfile",
    element: (
      <ProtectedRoute>
        <ViewProfile />
      </ProtectedRoute>
    ),
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <GlobalProvider>
        <ToastContainer
          position="bottom-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          transition={Bounce}
        />
        <RouterProvider router={router} />
      </GlobalProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
